import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";

import { AnimateNumberCount, ImageWithRetry } from "@src/components/atoms";
import CardContainer from "@src/components/cards/CardContainer";
import HorizontalLayout from "@src/components/cards/HorizontalLayout";
import VerticalLayout from "@src/components/cards/VerticalLayout";

const SavingsOrCharityCard = (props) => {
  const {
    backgroundColor = "primary",
    text,
    total,
    imgUrl,
    allowVerticalDisplay,
    className = "",
    dropShadow = false,
    isDonations = false,
    handleClick,
  } = props;

  return (
    <CardContainer
      bgColor={`${backgroundColor}-100`}
      shadow={dropShadow || handleClick}
      className={className}
      padding={0}
      onClick={() => {
        if (handleClick) {
          let redirect = "/dashboard/impact";
          if (isDonations) {
            redirect = "/dashboard/impact#donations";
          }
          handleClick(redirect, "TOTAL_SAVINGS_SELECTION");
        }
      }}
    >
      {allowVerticalDisplay ? (
        <VerticalLayout layoutType={"flex-top"}>
          <ImageWithRetry
            className={`h-20 w-auto rounded-xl mx-auto my-2`}
            src={imgUrl}
            alt="Carbon Savings"
          />
          <div className="flex flex-col grow items-center">
            <span className={`${allowVerticalDisplay ? "md:pt-3" : ""}`}>
              {text}
            </span>
            {total && (
              <span className="text-3xl font-bold pt-2">
                <AnimateNumberCount total={total} />
              </span>
            )}
          </div>
        </VerticalLayout>
      ) : (
        <HorizontalLayout ratio={[1, 2]} px={2} gap={2}>
          <div className="h-full flex items-center">
            <ImageWithRetry
              className={`px-2 w-full my-auto rounded-xl}`}
              src={imgUrl}
              alt="Carbon Savings"
            />
          </div>
          <div
            className={`flex flex-col grow p-2 ${total ? "items-center text-center" : "items-stretch text-left"}`}
          >
            <span className={`${allowVerticalDisplay ? "md:pt-3" : ""}`}>
              {text}
            </span>
            {total && (
              <span className="text-3xl font-bold pt-2">
                <AnimateNumberCount total={total} />
              </span>
            )}
          </div>
        </HorizontalLayout>
      )}
    </CardContainer>
  );
};

export const savingsOrCharityCardControls = {
  bestEvent: {
    propType: PropTypes.object,
    description: "Best event data object",
    controlType: "object",
  },
  getDynamicContent: {
    propType: PropTypes.func,
    description: "Function to get dynamic content",
    disable: true,
  },
  handleClick: {
    propType: PropTypes.func,
    description: "Click handler for the card",
    disable: true,
  },
};

SavingsOrCharityCard.propTypes = AppUtils.getPropTypeFromControls(
  savingsOrCharityCardControls,
);

export default SavingsOrCharityCard;
